// removed by extract-text-webpack-plugin
module.exports = {"footer-info":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___jaYb8","body":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___2wXLd","dialog":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___HCvlq","table":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___33rK7"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/COGSModal/COGSModal.css
// module id = 2420
// module chunks = 0